'use strict';

var AFM = require('../lib/animate/FrameManager.js');

/**
 * @class
 * Example use:
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  window.addEventListener('resize', resizeDebouncer.run, false);
 *  
 * Or, if using JQuery (but you can also 
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  $(window).bind('resize', resizeDebouncer.run);
 * 
 * Or, all on one line:
 *  $(window).bind('resize', (new Debouncer(callbackFn)).run);
 *  
 *  @param {function} callback 
 *  @param {number|String} [timing] - If 'string', specify the phase of FrameManager (AFM) to run on (e.i. 'read' or 'write). 
 *  					If number, the interval in ms to use to debounce. If not specified, the debouncer uses FrameManager's 'write'.
 *  @param {boolean} [immediate=false] - If `immediate` is set to true, the callback function is called on the leading edge and at the end of the interval if an event happens since first event but not during waiting period. If false, called at the end of each interval and not at the start.
 */
function Debouncer(callback, timing, immediate) {
	var self = this;
	
	this._callback = callback;
	this._immediate = immediate;
	
	if (timing === undefined || timing === null) {
		// TODO Maybe instead of this we make two functions instead of 'run' ('.readRun' and '.writeRun') and get rid of  the timout and 'immediate' options.
		this._afmPhase = 'write';
	} else if (typeof timing === 'string' || timing instanceof String) {
		// 'timing' should specify the phase of AFM to run on.
		this._afmPhase = timing;
	} else {
		// Assuming number
		this._timeout = timing;
	}
	
	this._waitingID = null;
	
	this._laterFn = function() {
		self._waitingID = null;
		if (self._immediate !== true || self._immediateSkipped === true) {
			self._immediateSkipped = null;
			self._callback.apply(self._callbackThis, self._callbackArgs);
		}
	}
	
	/**
	 * This will run the callback provided during construction of a Debouncer.
	 * Any passed arguments to run(...) will be passed to the callback.
	 * Calls are debounced using requsetAnimationFrame via FrameManager.
	 * @public
	 */
	this.run = function() {
		_run(self, this, arguments);
	};
}

/**
 * @private
 */
function _run(debouncer, thisArg, args) {
	debouncer._callbackThis = thisArg;
	debouncer._callbackArgs = args;
	
	if (debouncer._immediate === true) {
		if (debouncer._waitingID === null) {
			// Call now (if set to immediate and not waiting).
			debouncer._immediateSkipped = false;
			debouncer._callback.apply(debouncer._callbackThis, debouncer._callbackArgs);
		} else {
			debouncer._immediateSkipped = true;
		}
	}

	if (debouncer._waitingID === null) {
		if (debouncer._timeout === undefined) {
			AFM.once(debouncer._afmPhase, debouncer._laterFn);
		} else {
			debouncer._waitingID = setTimeout(debouncer._laterFn, debouncer._timeout);
		}
	}
}

/**
 * Run the callback method immediately without debouncing.
 * Any active debouncing is canceled first.
 * @public
 */
Debouncer.prototype.runNow = function() {
	this.cancel();
	this._callback.apply(this, arguments);
}
/**
 * Cancel a call to 'run'.
 * @public
 */
Debouncer.prototype.cancel = function() {
	if (this._timeout === undefined) {
		AFM.off(this._afmPhase, this._laterFn, true); // 'true' means we are removing a 'once' listener.
	} else {
		clearTimeout(this._waitingID);
	}
	this._waitingID = null;
}

module.exports = Debouncer;
